module.exports = __webpack_public_path__ + "static/media/hero-2.21de0e9e.jpg";